// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Varela+Round);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.welcome {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  width: 100vw;
  height: 100vh;
  font-family: "Poppins", sans-serif;
  overflow: hidden;
  position: relative;
  perspective: clamp(400px, 100vw, 1000px);
  background-color: black;
}

.welcome::before,
.welcome::after {
  content: "";
  position: fixed;
  z-index: 10;
  left: 0;
  right: 0;
  height: 30vh;
}

.gallery {
  display: flex;
  gap: 1vw;
  width: 100%;
  height: 100vh;
  transform: translate(5%, -25%) rotate(-6deg) rotateX(10deg) rotateY(20deg);
}

.gallery_line {
  display: flex;
  flex-direction: column;
  gap: 1vw;
  width: 100%;
  height: -moz-fit-content;
  height: fit-content;
  animation: slide 30s linear infinite;
}

.gallery_line:nth-child(2) {
  animation-direction: reverse;
}

.gallery_line img {
  flex: 1 1 auto;
  width: 100%;
  object-fit: cover;
}

@keyframes slide {
  0% {
    transform: translatey(0);
  }
  100% {
    transform: translatey(-50%);
  }
}
.Me {
  position: fixed;
  z-index: 15;
  bottom: 20px;
  left: 50%;
  color: #111;
  transform: translateX(-50%);
  font-weight: 700;
  text-align: center;
  opacity: 0.7;
}

.overlay {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.3);
  width: 100vw;
  height: 100vh;
  z-index: 4;
  animation: fader 5s 3s ease-in-out forwards;
}

@keyframes fader {
  0% {
    background-color: rgba(0, 0, 0, 0.3);
  }
  100% {
    background-color: rgb(0, 0, 0);
  }
}
html {
  background-color: black;
}

@keyframes flickerL {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  100% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
}
@keyframes flickerO {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  72.66667% {
    color: rgba(255, 255, 255, 0.7);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white, 0 0 40px white;
  }
  73.33333% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  74% {
    color: rgba(255, 255, 255, 0.7);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white, 0 0 40px white;
  }
  74.66667% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  75.33333% {
    color: rgba(255, 255, 255, 0.7);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white, 0 0 40px white;
  }
  75.77778% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  94.44444% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgb(240, 0, 0);
    text-shadow: none;
  }
}
@keyframes flickerA {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  88.86667% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  88.88889% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
}
@keyframes flickerD {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  83.31111% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  83.33333% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
}
@keyframes flickerI {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  77.75556% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  77.77778% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
}
@keyframes flickerN {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  72.2% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  72.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
}
@keyframes flickerG {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  66.64444% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  66.66667% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgb(240, 0, 0);
    text-shadow: none;
  }
}
#content {
  position: absolute;
  top: 30%;
  left: 0;
  right: 0;
  width: auto;
  height: 5vw;
  transform: translateY(-50%);
  margin: 0 auto;
  text-align: center;
  z-index: 8;
}

#content li {
  display: inline-block;
  position: relative;
  padding: 0 1%;
  margin: 0 0.5%;
  width: 5vw;
  height: 5vw;
  list-style: none;
  font-family: "Varela Round";
  font-weight: bolder;
  font-size: 5vw;
  color: black;
  -webkit-text-stroke-width: 0.045vw;
  -webkit-text-stroke-color: rgb(240, 0, 0);
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
}

#content li:nth-child(1) {
  animation-name: flickerL;
  animation-delay: 0s;
  animation-duration: 4.5s;
}

#content li:nth-child(2) {
  animation-name: flickerO;
  animation-delay: 0.25s;
  animation-duration: 4.5s;
}

#content li:nth-child(3) {
  animation-name: flickerA;
  animation-delay: 0.5s;
  animation-duration: 4.5s;
}

#content li:nth-child(4) {
  animation-name: flickerD;
  animation-delay: 0.75s;
  animation-duration: 4.5s;
}

#content li:nth-child(5) {
  animation-name: flickerI;
  animation-delay: 1s;
  animation-duration: 4.5s;
}

#content li:nth-child(6) {
  animation-name: flickerN;
  animation-delay: 1.25s;
  animation-duration: 4.5s;
}

#content li:nth-child(7) {
  animation-name: flickerG;
  animation-delay: 1.5s;
  animation-duration: 4.5s;
}

#content li:nth-child(8) {
  animation-name: flickerG;
  animation-delay: 1.5s;
  animation-duration: 4.5s;
}

#content li:nth-child(9) {
  animation-name: flickerG;
  animation-delay: 1.5s;
  animation-duration: 4.5s;
}

#content2 {
  position: absolute;
  top: 45%;
  left: 0;
  right: 0;
  width: auto;
  height: 5vw;
  transform: translateY(-50%);
  margin: 0 auto;
  text-align: center;
  z-index: 8;
}

#content2 li {
  display: inline-block;
  position: relative;
  padding: 0 1%;
  margin: 0 0.5%;
  width: 5vw;
  height: 5vw;
  list-style: none;
  font-family: "Varela Round";
  font-weight: bolder;
  font-size: 5vw;
  color: black;
  -webkit-text-stroke-width: 0.045vw;
  -webkit-text-stroke-color: rgb(240, 0, 0);
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
  animation-delay: 2s;
}

#content2 li:nth-child(1) {
  animation-name: flickerL;
  animation-delay: 4s;
  animation-duration: 4.5s;
}

#content2 li:nth-child(2) {
  animation-name: flickerO;
  animation-delay: 4.25s;
  animation-duration: 4.5s;
}

#content2 li:nth-child(3) {
  animation-name: flickerA;
  animation-delay: 4.5s;
  animation-duration: 4.5s;
}

#content2 li:nth-child(4) {
  animation-name: flickerD;
  animation-delay: 4.75s;
  animation-duration: 4.5s;
}

#content2 li:nth-child(5) {
  animation-name: flickerI;
  animation-delay: 5s;
  animation-duration: 4.5s;
}

#content2 li:nth-child(6) {
  animation-name: flickerN;
  animation-delay: 5.25s;
  animation-duration: 4.5s;
}

#content2 li:nth-child(7) {
  animation-name: flickerG;
  animation-delay: 5.5s;
  animation-duration: 4.5s;
}

#content3 {
  position: absolute;
  top: 60%;
  left: 0;
  right: 0;
  width: auto;
  height: 5vw;
  transform: translateY(-50%);
  margin: 0 auto;
  text-align: center;
  z-index: 8;
}

#content3 li {
  display: inline-block;
  position: relative;
  padding: 0 1%;
  margin: 0 0.5%;
  width: 5vw;
  height: 5vw;
  list-style: none;
  font-family: "Varela Round";
  font-weight: bolder;
  font-size: 5vw;
  color: black;
  -webkit-text-stroke-width: 0.045vw;
  -webkit-text-stroke-color: rgb(240, 0, 0);
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
}

#content3 li:nth-child(1) {
  animation-name: flickerL;
  animation-delay: 8s;
  animation-duration: 4.5s;
}

#content3 li:nth-child(2) {
  animation-name: flickerO;
  animation-delay: 8.25s;
  animation-duration: 4.5s;
}

#content3 li:nth-child(3) {
  animation-name: flickerA;
  animation-delay: 8.5s;
  animation-duration: 4.5s;
}

#content3 li:nth-child(4) {
  animation-name: flickerD;
  animation-delay: 8.75s;
  animation-duration: 4.5s;
}

#content3 li:nth-child(5) {
  animation-name: flickerI;
  animation-delay: 9s;
  animation-duration: 4.5s;
}

#content3 li:nth-child(6) {
  animation-name: flickerN;
  animation-delay: 9.25s;
  animation-duration: 4.5s;
}

#content3 li:nth-child(7) {
  animation-name: flickerG;
  animation-delay: 9.5s;
  animation-duration: 4.5s;
}

@keyframes comeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.golden-button {
  position: absolute;
  top: 75%;
  left: 0;
  right: 0;
  width: 12em;
  transform: translateY(-50%);
  margin: 0 auto;
  text-align: center;
  z-index: 8;
  opacity: 0;
  animation: comeIn 1s 6s ease-in-out forwards;
  touch-action: manipulation;
  display: inline-block;
  outline: none;
  font-family: inherit;
  font-size: 2em;
  box-sizing: border-box;
  border: none;
  border-radius: 0.3em;
  height: 3.75em;
  line-height: 2.5em;
  text-transform: uppercase;
  padding: 0 1em;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(110, 80, 20, 0.4), inset 0 -2px 5px 1px rgb(139, 66, 8), inset 0 -1px 1px 3px rgb(250, 227, 133);
  background-image: linear-gradient(160deg, #a54e07, #b47e11, #fef1a2, #bc881b, #a54e07);
  border: 1px solid #a55d07;
  color: rgb(120, 50, 5);
  text-shadow: 0 2px 2px rgb(250, 227, 133);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  background-size: 100% 100%;
  background-position: center;
}

.golden-button:focus,
.golden-button:hover {
  background-size: 150% 150%;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23), inset 0 -2px 5px 1px #b17d10, inset 0 -1px 1px 3px rgb(250, 227, 133);
  border: 1px solid rgba(165, 93, 7, 0.6);
  color: rgba(120, 50, 5, 0.8);
}

.golden-button:active {
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(110, 80, 20, 0.4), inset 0 -2px 5px 1px #b17d10, inset 0 -1px 1px 3px rgb(250, 227, 133);
}`, "",{"version":3,"sources":["webpack://./src/pages/Welcome/Styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,kCAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCAAA;EACA,uBAAA;AAEF;;AACA;;EAEE,WAAA;EACA,eAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;AAEF;;AACA;EACE,aAAA;EACA,QAAA;EACA,WAAA;EAGA,aAAA;EACA,0EAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,wBAAA;EAAA,mBAAA;EACA,oCAAA;AAAF;;AAGA;EACE,4BAAA;AAAF;;AAGA;EACE,cAAA;EACA,WAAA;EACA,iBAAA;AAAF;;AAGA;EACE;IACE,wBAAA;EAAF;EAEA;IACE,2BAAA;EAAF;AACF;AAGA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AADF;;AAIA;EACE,kBAAA;EACA,oCAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,2CAAA;AADF;;AAIA;EACE;IACE,oCAAA;EADF;EAIA;IACE,8BAAA;EAFF;AACF;AAMA;EACE,uBAAA;AAJF;;AAOA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAJF;EAOA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EALF;EAOA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EALF;EAOA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EALF;EAOA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EALF;EAOA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EALF;EAOA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EALF;EAOA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EALF;EAOA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EALF;EAOA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EALF;AACF;AAQA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EANF;EASA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAPF;EASA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAPF;EASA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAPF;EASA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAPF;EASA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAPF;EASA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAPF;EASA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAPF;EASA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAPF;EASA;IACE,+BAAA;IACA,gCAAA;IACA,6EAAA;EAPF;EAUA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EARF;EAUA;IACE,+BAAA;IACA,gCAAA;IACA,6EAAA;EARF;EAWA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EATF;EAWA;IACE,+BAAA;IACA,gCAAA;IACA,6EAAA;EATF;EAYA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAVF;EAYA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAVF;EAYA;IACE,YAAA;IACA,yCAAA;IACA,iBAAA;EAVF;AACF;AAaA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAXF;EAcA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAZF;EAcA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAZF;EAcA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAZF;EAcA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAZF;EAcA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAZF;EAcA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAZF;EAcA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAZF;EAcA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAZF;EAcA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAZF;EAcA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAZF;EAcA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAZF;AACF;AAeA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAbF;EAgBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAdF;EAgBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAdF;EAgBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAdF;EAgBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAdF;EAgBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAdF;EAgBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAdF;EAgBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAdF;EAgBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAdF;EAgBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAdF;EAgBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAdF;EAgBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAdF;AACF;AAiBA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAfF;EAkBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAhBF;EAkBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAhBF;EAkBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAhBF;EAkBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAhBF;EAkBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAhBF;EAkBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAhBF;EAkBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAhBF;EAkBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAhBF;EAkBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAhBF;EAkBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAhBF;EAkBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAhBF;AACF;AAmBA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAjBF;EAoBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAlBF;EAoBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAlBF;EAoBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAlBF;EAoBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAlBF;EAoBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAlBF;EAoBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAlBF;EAoBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAlBF;EAoBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAlBF;EAoBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAlBF;EAoBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAlBF;EAoBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAlBF;AACF;AAqBA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAnBF;EAsBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EApBF;EAsBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EApBF;EAsBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EApBF;EAsBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EApBF;EAsBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EApBF;EAsBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EApBF;EAsBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EApBF;EAsBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EApBF;EAsBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EApBF;EAsBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EApBF;EAsBA;IACE,YAAA;IACA,yCAAA;IACA,iBAAA;EApBF;AACF;AAuBA;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AArBF;;AAuBA;EACE,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,kCAAA;EACA,yCAAA;EACA,mCAAA;EACA,6BAAA;AApBF;;AAsBA;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AAnBF;;AAqBA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AAlBF;;AAoBA;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AAjBF;;AAmBA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AAhBF;;AAkBA;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AAfF;;AAiBA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AAdF;;AAgBA;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AAbF;;AAeA;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AAZF;;AAcA;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AAXF;;AAcA;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AAXF;;AAaA;EACE,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,kCAAA;EACA,yCAAA;EACA,mCAAA;EACA,6BAAA;EACA,mBAAA;AAVF;;AAYA;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AATF;;AAWA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AARF;;AAUA;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AAPF;;AASA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AANF;;AAQA;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AALF;;AAOA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AAJF;;AAMA;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AAHF;;AAKA;EACE,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,kCAAA;EACA,yCAAA;EACA,mCAAA;EACA,6BAAA;AAFF;;AAIA;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AADF;;AAGA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AAAF;;AAEA;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AACF;;AACA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AAEF;;AAAA;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AAGF;;AADA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AAIF;;AAFA;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AAKF;;AAFA;EACE;IACE,UAAA;EAKF;EAFA;IACE,UAAA;EAIF;AACF;AADA;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,4CAAA;EAEA,0BAAA;EACA,qBAAA;EACA,aAAA;EACA,oBAAA;EACA,cAAA;EACA,sBAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,0JAAA;EAGA,sFAAA;EAQA,yBAAA;EACA,sBAAA;EACA,yCAAA;EACA,eAAA;EACA,gCAAA;EACA,0BAAA;EACA,2BAAA;AAPF;;AAUA;;EAEE,0BAAA;EACA,iJAAA;EAEA,uCAAA;EACA,4BAAA;AARF;;AAWA;EACE,kJAAA;AARF","sourcesContent":[".welcome {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0;\n  width: 100vw;\n  height: 100vh;\n  font-family: \"Poppins\", sans-serif;\n  overflow: hidden;\n  position: relative;\n  perspective: clamp(400px, 100vw, 1000px);\n  background-color: black;\n}\n\n.welcome::before,\n.welcome::after {\n  content: \"\";\n  position: fixed;\n  z-index: 10;\n  left: 0;\n  right: 0;\n  height: 30vh;\n}\n\n.gallery {\n  display: flex;\n  gap: 1vw;\n  width: 100%;\n  // max-width: 1200px;\n  // min-width: 500px;\n  height: 100vh;\n  transform: translate(5%, -25%) rotate(-6deg) rotateX(10deg) rotateY(20deg);\n}\n\n.gallery_line {\n  display: flex;\n  flex-direction: column;\n  gap: 1vw;\n  width: 100%;\n  height: fit-content;\n  animation: slide 30s linear infinite;\n}\n\n.gallery_line:nth-child(2) {\n  animation-direction: reverse;\n}\n\n.gallery_line img {\n  flex: 1 1 auto;\n  width: 100%;\n  object-fit: cover;\n}\n\n@keyframes slide {\n  0% {\n    transform: translatey(0);\n  }\n  100% {\n    transform: translatey(-50%);\n  }\n}\n\n.Me {\n  position: fixed;\n  z-index: 15;\n  bottom: 20px;\n  left: 50%;\n  color: #111;\n  transform: translateX(-50%);\n  font-weight: 700;\n  text-align: center;\n  opacity: 0.7;\n}\n\n.overlay {\n  position: absolute;\n  background-color: rgba(0, 0, 0, 0.3);\n  width: 100vw;\n  height: 100vh;\n  z-index: 4;\n  animation: fader 5s 3s ease-in-out forwards;\n}\n\n@keyframes fader {\n  0% {\n    background-color: rgba(0, 0, 0, 0.3);\n  }\n\n  100% {\n    background-color: rgba(0, 0, 0, 1);\n  }\n}\n\n@import url(https://fonts.googleapis.com/css?family=Varela+Round);\nhtml {\n  background-color: black;\n}\n\n@keyframes flickerL {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  100% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n    // opacity: 1;\n  }\n}\n@keyframes flickerO {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  72.66667% {\n    color: rgba(255, 255, 255, 0.7);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white,\n      0 0 40px white;\n  }\n  73.33333% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  74% {\n    color: rgba(255, 255, 255, 0.7);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white,\n      0 0 40px white;\n  }\n  74.66667% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  75.33333% {\n    color: rgba(255, 255, 255, 0.7);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white,\n      0 0 40px white;\n  }\n  75.77778% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  94.44444% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  100% {\n    color: black;\n    -webkit-text-stroke-color: rgba(240, 0, 0, 1);\n    text-shadow: none;\n    // opacity: 1;\n  }\n}\n@keyframes flickerA {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  88.86667% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  88.88889% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  100% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 1;\n  }\n}\n@keyframes flickerD {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  83.31111% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  83.33333% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  100% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 1;\n  }\n}\n@keyframes flickerI {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  77.75556% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  77.77778% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  100% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 1;\n  }\n}\n@keyframes flickerN {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  72.2% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  72.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  100% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 1;\n  }\n}\n@keyframes flickerG {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  66.64444% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  66.66667% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  100% {\n    color: black;\n    -webkit-text-stroke-color: rgba(240, 0, 0, 1);\n    text-shadow: none;\n    // opacity: 1;\n  }\n}\n#content {\n  position: absolute;\n  top: 30%;\n  left: 0;\n  right: 0;\n  width: auto;\n  height: 5vw;\n  transform: translateY(-50%);\n  margin: 0 auto;\n  text-align: center;\n  z-index: 8;\n}\n#content li {\n  display: inline-block;\n  position: relative;\n  padding: 0 1%;\n  margin: 0 0.5%;\n  width: 5vw;\n  height: 5vw;\n  list-style: none;\n  font-family: \"Varela Round\";\n  font-weight: bolder;\n  font-size: 5vw;\n  color: black;\n  -webkit-text-stroke-width: 0.045vw;\n  -webkit-text-stroke-color: rgba(240, 0, 0, 1);\n  animation-iteration-count: infinite;\n  animation-fill-mode: forwards;\n}\n#content li:nth-child(1) {\n  animation-name: flickerL;\n  animation-delay: 0s;\n  animation-duration: 4.5s;\n}\n#content li:nth-child(2) {\n  animation-name: flickerO;\n  animation-delay: 0.25s;\n  animation-duration: 4.5s;\n}\n#content li:nth-child(3) {\n  animation-name: flickerA;\n  animation-delay: 0.5s;\n  animation-duration: 4.5s;\n}\n#content li:nth-child(4) {\n  animation-name: flickerD;\n  animation-delay: 0.75s;\n  animation-duration: 4.5s;\n}\n#content li:nth-child(5) {\n  animation-name: flickerI;\n  animation-delay: 1s;\n  animation-duration: 4.5s;\n}\n#content li:nth-child(6) {\n  animation-name: flickerN;\n  animation-delay: 1.25s;\n  animation-duration: 4.5s;\n}\n#content li:nth-child(7) {\n  animation-name: flickerG;\n  animation-delay: 1.5s;\n  animation-duration: 4.5s;\n}\n#content li:nth-child(8) {\n  animation-name: flickerG;\n  animation-delay: 1.5s;\n  animation-duration: 4.5s;\n}\n#content li:nth-child(9) {\n  animation-name: flickerG;\n  animation-delay: 1.5s;\n  animation-duration: 4.5s;\n}\n\n#content2 {\n  position: absolute;\n  top: 45%;\n  left: 0;\n  right: 0;\n  width: auto;\n  height: 5vw;\n  transform: translateY(-50%);\n  margin: 0 auto;\n  text-align: center;\n  z-index: 8;\n}\n#content2 li {\n  display: inline-block;\n  position: relative;\n  padding: 0 1%;\n  margin: 0 0.5%;\n  width: 5vw;\n  height: 5vw;\n  list-style: none;\n  font-family: \"Varela Round\";\n  font-weight: bolder;\n  font-size: 5vw;\n  color: black;\n  -webkit-text-stroke-width: 0.045vw;\n  -webkit-text-stroke-color: rgba(240, 0, 0, 1);\n  animation-iteration-count: infinite;\n  animation-fill-mode: forwards;\n  animation-delay: 2s;\n}\n#content2 li:nth-child(1) {\n  animation-name: flickerL;\n  animation-delay: 4s;\n  animation-duration: 4.5s;\n}\n#content2 li:nth-child(2) {\n  animation-name: flickerO;\n  animation-delay: 4.25s;\n  animation-duration: 4.5s;\n}\n#content2 li:nth-child(3) {\n  animation-name: flickerA;\n  animation-delay: 4.5s;\n  animation-duration: 4.5s;\n}\n#content2 li:nth-child(4) {\n  animation-name: flickerD;\n  animation-delay: 4.75s;\n  animation-duration: 4.5s;\n}\n#content2 li:nth-child(5) {\n  animation-name: flickerI;\n  animation-delay: 5s;\n  animation-duration: 4.5s;\n}\n#content2 li:nth-child(6) {\n  animation-name: flickerN;\n  animation-delay: 5.25s;\n  animation-duration: 4.5s;\n}\n#content2 li:nth-child(7) {\n  animation-name: flickerG;\n  animation-delay: 5.5s;\n  animation-duration: 4.5s;\n}\n\n#content3 {\n  position: absolute;\n  top: 60%;\n  left: 0;\n  right: 0;\n  width: auto;\n  height: 5vw;\n  transform: translateY(-50%);\n  margin: 0 auto;\n  text-align: center;\n  z-index: 8;\n}\n#content3 li {\n  display: inline-block;\n  position: relative;\n  padding: 0 1%;\n  margin: 0 0.5%;\n  width: 5vw;\n  height: 5vw;\n  list-style: none;\n  font-family: \"Varela Round\";\n  font-weight: bolder;\n  font-size: 5vw;\n  color: black;\n  -webkit-text-stroke-width: 0.045vw;\n  -webkit-text-stroke-color: rgba(240, 0, 0, 1);\n  animation-iteration-count: infinite;\n  animation-fill-mode: forwards;\n}\n#content3 li:nth-child(1) {\n  animation-name: flickerL;\n  animation-delay: 8s;\n  animation-duration: 4.5s;\n}\n#content3 li:nth-child(2) {\n  animation-name: flickerO;\n  animation-delay: 8.25s;\n  animation-duration: 4.5s;\n}\n#content3 li:nth-child(3) {\n  animation-name: flickerA;\n  animation-delay: 8.5s;\n  animation-duration: 4.5s;\n}\n#content3 li:nth-child(4) {\n  animation-name: flickerD;\n  animation-delay: 8.75s;\n  animation-duration: 4.5s;\n}\n#content3 li:nth-child(5) {\n  animation-name: flickerI;\n  animation-delay: 9s;\n  animation-duration: 4.5s;\n}\n#content3 li:nth-child(6) {\n  animation-name: flickerN;\n  animation-delay: 9.25s;\n  animation-duration: 4.5s;\n}\n#content3 li:nth-child(7) {\n  animation-name: flickerG;\n  animation-delay: 9.5s;\n  animation-duration: 4.5s;\n}\n\n@keyframes comeIn {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n.golden-button {\n  position: absolute;\n  top: 75%;\n  left: 0;\n  right: 0;\n  width: 12em;\n  transform: translateY(-50%);\n  margin: 0 auto;\n  text-align: center;\n  z-index: 8;\n  opacity: 0;\n  animation: comeIn 1s 6s ease-in-out forwards;\n\n  touch-action: manipulation;\n  display: inline-block;\n  outline: none;\n  font-family: inherit;\n  font-size: 2em;\n  box-sizing: border-box;\n  border: none;\n  border-radius: 0.3em;\n  height: 3.75em;\n  line-height: 2.5em;\n  text-transform: uppercase;\n  padding: 0 1em;\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(110, 80, 20, 0.4),\n    inset 0 -2px 5px 1px rgba(139, 66, 8, 1),\n    inset 0 -1px 1px 3px rgba(250, 227, 133, 1);\n  background-image: linear-gradient(\n    160deg,\n    #a54e07,\n    #b47e11,\n    #fef1a2,\n    #bc881b,\n    #a54e07\n  );\n  border: 1px solid #a55d07;\n  color: rgb(120, 50, 5);\n  text-shadow: 0 2px 2px rgba(250, 227, 133, 1);\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  background-size: 100% 100%;\n  background-position: center;\n}\n\n.golden-button:focus,\n.golden-button:hover {\n  background-size: 150% 150%;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23),\n    inset 0 -2px 5px 1px #b17d10, inset 0 -1px 1px 3px rgba(250, 227, 133, 1);\n  border: 1px solid rgba(165, 93, 7, 0.6);\n  color: rgba(120, 50, 5, 0.8);\n}\n\n.golden-button:active {\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(110, 80, 20, 0.4),\n    inset 0 -2px 5px 1px #b17d10, inset 0 -1px 1px 3px rgba(250, 227, 133, 1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
